import React from 'react';
import PropTypes from "prop-types";
import { TableCell, TableHead, TableRow, TableSortLabel, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  cell: {
    padding: theme.spacing(0.5), // reduce padding
    fontSize: '0.75rem', // reduce font size
  },
  headerCell: {
    minWidth: 50,
    padding: theme.spacing(0.5),
    fontSize: '0.75rem',
  },
}));

export const TableHeadLineasPrestacion = (props) => {
  const {
    order,
    orderBy,
    onRequestSort,
  } = props;
  
  const classes = useStyles();

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = [
    { align: "left", enabledSort: false, visible: true },
    { align: "left", enabledSort: false, visible: true },
    { id: "sinCobroCoseguro", align: "left", label: "Sin cobro Cos", enabledSort: true, visible: true },
    { id: "nroLinea", align: "left", label: "N° Línea", enabledSort: true, visible: true },
    { id: "carnet", disablePadding: true, label: "Carnet / Afiliado", align: "center", enabledSort: true, minWidth: 200, visible: true },
    { id: "codNom", disablePadding: false, label: "Cod. Práctica", align: "center", enabledSort: true, visible: true },
    { id: "desMat", disablePadding: false, label: "Descripcion Práctica", align: "lecenterft", enabledSort: true, visible: true },

    { id: "fechaPrestacion", disablePadding: false, label: "Fecha Realización", align: "center", enabledSort: true, visible: true },
    { id: "cantidad", disablePadding: false, label: "Cantidad", align: "center", enabledSort: false, visible: true },
    { id: "importe", disablePadding: false, label: "Importe Unit", align: "center", enabledSort: true, visible: true },
    { id: "convenio", disablePadding: false, label: "Convenio", align: "center", enabledSort: false, visible: true },
    { id: "nroValidacion", disablePadding: false, label: "Nro Validación", align: "center", enabledSort: true, visible: props.comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaPortalPrestador },
    { id: "idSolicitud", disablePadding: false, label: "IdSolicitud", align: "center", enabledSort: true, visible: props.comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaAutorizacion },
    { id: "subtotal", disablePadding: false, label: "Subtotal", align: "center", enabledSort: false, visible: true },
    { id: "coseguro", disablePadding: false, label: "Coseguro", align: "center", enabledSort: false, visible: true },
    { id: "coseguroFacturado", disablePadding: false, label: "Coseguro Facturado", align: "center", enabledSort: false, visible: true },
    { id: "idCategoria", disablePadding: false, label: "Categoría", align: "center", enabledSort: false, visible: true },
    // { id: "convenioCoseguroFacturadoDescontado", disablePadding: false, label: "CD CoseguroFact", align: "center", enabledSort: false, visible: true },
    { id: "importeDebito", disablePadding: false, label: "Debito", align: "center", enabledSort: false, visible: true },
    { id: "total", disablePadding: false, label: "Total a Pagar", align: "center", enabledSort: false, visible: true },
    { id: "btn", align: "center", enabledSort: false }
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.filter(s => s.visible).map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            className={classes.headerCell}
          >
            {headCell.enabledSort
              ?
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                </TableSortLabel>
              :
                <>{headCell.label}</>
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

TableHeadLineasPrestacion.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  comprobanteSeleccionado: PropTypes.object.isRequired,
};